import View from './View.js';
import previewView from './previewView.js';
import icons from 'url:../../img/icons.svg'; //Parcel 2

class BookmarksView extends View {
  _parentElement = document.querySelector('.bookmarks__list');
  _errorMessage = `No bookmarks yet. Find a nice recipe and bookmark it!`;
  _message = ``;

  addHandlerRender(handler) {
    window.addEventListener('load', handler);
  }

  // this._data is all of the bookmarks
  _generateMarkup() {
    // needs to return a string
    return this._data
      .map(bookmark => previewView.render(bookmark, false)) //creates an array of strings
      .join(''); // creates one long string that we want to render
  }
}

export default new BookmarksView();
